import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";
import { getToken, getCurrentProject, logout } from "@/lib/auth";

// Attach JWT token + X-Project-ID to every outgoing request
axios.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const projectId = getCurrentProject();
  if (projectId) config.headers["X-Project-ID"] = projectId;
  return config;
});

// On 401, clear all auth state and redirect to login
axios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      logout();
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
